import dayjs from "dayjs";

export const isToday = (dateString) => {
    const inputDate = new Date(dateString);
    const today = new Date();
    return (
        inputDate.getDate() === today.getDate() &&
        inputDate.getMonth() === today.getMonth() &&
        inputDate.getFullYear() === today.getFullYear()
    );
};

export const isEqualDate = (dateString, date) => {
    const inputDate = new Date(dateString);
    const day = new Date(date);
    return (
        inputDate.getDate() === day.getDate() &&
        inputDate.getMonth() === day.getMonth() &&
        inputDate.getFullYear() === day.getFullYear()
    );
};

export const isBetweenOrEqualDate = (date, startDate, endDate) => {
    const targetDate = new Date(date).getTime();
    const start = new Date(startDate).getTime();
    const end = new Date(endDate).getTime();
    return targetDate >= start && targetDate <= end;
};

export const isTomonth = (dateString) => {
    const inputDate = new Date(dateString);
    const today = new Date();
    return (
        inputDate.getMonth() === today.getMonth() &&
        inputDate.getFullYear() === today.getFullYear()
    );
};

export const isSameYear = (dateStr) => {
    const givenDate = new Date(dateStr);
    const currentYear = new Date().getFullYear();
    return givenDate.getFullYear() === currentYear;
};

export const dateView = (date) => {
    const [datePart, timePart] = date.split("T");
    return `${datePart} - ${timePart?.split(".")[0] || timePart}`;
};

export const frenchDate = (date) => {
    if (date) {
        const [datePart, timePart] = date?.split("T");
        const [year, month, day] = datePart?.split("-");
        return `${day}/${month}/${year} - ${timePart?.split(".")?.[0] || ""}`;
    }
    return "";
};

export const frenchDateOnly = (date) => {
    if (date) {
        const [year, month, day] = date?.split("T")[0]?.split("-");
        return `${day}/${month}/${year}`;
    }
    return "";
};

export const frenchDateSimple = (date) => {
    const [datePart, timePart] = date.split("T");
    const [year, month, day] = datePart.split("-");
    return `${day}/${month}/${year} - ${timePart || ""}`;
};

export const frenchDatews = (date) => {
    if (date) {
        const [datePart, timePart] = date?.split("T");
        const [year, month, day] = datePart?.split("-");
        const [hour, minute] = timePart?.split(":");
        return `${day}/${month}/${year} à ${hour}:${minute}`;
    }
    return "";
};

export const displayDateEcheance = (date) => {
    if (date) {
        return dayjs(date).hour(23).minute(59).second(59).format("DD/MM/YYYY HH:mm:ss");
    }
    return "";
};

export const frenchMonth = (month) => {
    const months = {
        "01": "Janvier", "02": "Février", "03": "Mars", "04": "Avril",
        "05": "Mai", "06": "Juin", "07": "Juillet", "08": "Août",
        "09": "Septembre", "10": "Octobre", "11": "Novembre", "12": "Décembre"
    };
    return months[month] || "";
};

export const formatFrenchDate = (dateInput) => {
    const date = new Date(dateInput);
    const options = {
        day: "2-digit", month: "long", year: "numeric",
        hour: "2-digit", minute: "2-digit",
    };
    return date.toLocaleDateString("fr-FR", options).replace(",", " à");
};

export const getDurationBetweenDates = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    if (isNaN(start) || isNaN(end)) return "Date(s) invalide(s)";

    let diffMs = Math.abs(end - start);
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    diffMs %= (1000 * 60 * 60 * 24);
    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    diffMs %= (1000 * 60 * 60);
    const minutes = Math.floor(diffMs / (1000 * 60));
    diffMs %= (1000 * 60);
    const seconds = Math.floor(diffMs / 1000);
    return `${days}j ${hours}h ${minutes}m ${seconds}s`;
};

export const getDaysDurationBetweenDates = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    if (isNaN(start) || isNaN(end)) return "Date(s) invalide(s)";
    return Math.floor(Math.abs(end - start) / (1000 * 60 * 60 * 24));
};

export const numberOfDaysBetweenDates = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    return Math.ceil(Math.abs(end - start) / (1000 * 3600 * 24));
};

export const convertDateFormatDDMMYYYYToYYYYMMDD = (date) => {
    const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
    const match = date.match(regex);
    if (!match) throw new Error("Invalid date format. Expected DD/MM/YYYY.");
    return `${match[3]}-${match[2]}-${match[1]}`;
};
